/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

window.sbBehaviours = window.sbBehaviours || {};
    sbBehaviours.authAndSubmit = {
        submitDetails: function (url, method,body, headervalue, encryptedData) {
            var self = this;
    if (this.authMethods !==undefined && this.authMethods.length && Object.values(this.authMethods[this.authMethods.length - 1]).includes("OOBN")) {
      let event = {};
      event.message = "m_processing_mobile_notification";
      this.fire('start-processing-loader', event);
    } else {
      this.fire('start-processing-loader');
    }
            
            let ajaxCall = document.createElement('oe-ajax');
            ajaxCall.contentType = "application/json";
            ajaxCall.handleAs = "json";
            ajaxCall.url = url;
            ajaxCall.method = method;            
            ajaxCall.body = body;

        if (ajaxCall.header == undefined || Object.keys(ajaxCall.header).length == 0) {
            ajaxCall.headers["authorizationDetails"] = JSON.stringify({
                primaryAccessCode: headervalue.primaryAccessCode ? headervalue.primaryAccessCode : "",
                secondaryAccessCode: headervalue.secondaryAccessCode ? headervalue.secondaryAccessCode :
                    "",
                //PrincipalId needs to be passed in Request headers for authorization, Hence passing principalId in request headers instead of userid changes are done as part of defect 388678
                // userId: clientStorage.get(storageType.session, 'RMId') ? clientStorage.get(storageType.session, 'RMId') : clientStorage.get(storageType.session, 'userId'),
                userId: clientStorage.get(storageType.session, 'RMId') ? clientStorage.get(storageType.session, 'RMId') : clientStorage.get(storageType.session, 'principalId'),
                acceptTermsAndConditions: "",
                userRemarks: headervalue.userRemarks ? headervalue.userRemarks : ""
            });
        }

        if (this.authMethods !==undefined && this.authMethods.length && (Object.values(this.authMethods[this.authMethods.length - 1]).includes("OOBN"))) {
            ajaxCall.headers["authorizationDetails"] = JSON.parse(ajaxCall.headers["authorizationDetails"]);
            ajaxCall.headers.authorizationDetails.isMobileNTFConfirmation = this.authMethods[this.authMethods.length - 1].isMobileNTFConfirmation;
            ajaxCall.headers["authorizationDetails"] = JSON.stringify(ajaxCall.headers["authorizationDetails"]);
        }
            if (encryptedData !== undefined) {
                ajaxCall.headers["encrypteddata"] = sbEncrypt.encrypt(JSON.stringify(encryptedData));
            }

            ajaxCall.addEventListener('response', function (event) {
                self.loaderActive=false;
                self.fire('stop-processing-loader');
                if (event.detail.__data.status === 200 || event.detail.__data.status === 204) {
                    self.successMessage = event.detail.__data.status;
                    if(typeof self._callSucessPage == 'function') {
                        if(self.shadowRoot.activeElement)
                            self.shadowRoot.activeElement.blur();
                        self._callSucessPage(event);
                    }
                }
            });
            ajaxCall.addEventListener('error', function (event) {
                self.loaderActive=false;
                self.fire('stop-processing-loader');
                 if (event.detail.request.__data.status === 401) {
                    if (event.detail.request.__data.response.error.message
                        .header != undefined) {
                        this.header = {
                            "primaryAccessCode": event.detail.request.__data.response.error.message
                                .header.authorization.firstAuthorizationMode,
                            "secondaryAccessCode": event.detail.request.__data.response.error
                            .message.header.authorization.secondAuthorizationMode,
                        "isMobileNTFConfirmation": event.detail.request.__data.response.error
                            .message.header.authorization.isMobileNTFConfirmation
                        } 
                        if(event.detail.request.__data.response.error.message
                            .header.authorization.transactionType){
                            this.header.transactionType=event.detail.request.__data.response.error.message
                            .header.authorization.transactionType;
                          }                       
                        self.headerObject = this.header;
                        self.setAuthorizationModes(this.header);                        
                        self._callAuthPage();
                    }
					 else if (JSON.parse(event.detail.request.xhr.getResponseHeader('channelcontext') != undefined)) {
              var auth = JSON.parse(event.detail.request.xhr.getResponseHeader('channelcontext'));
						  this.header = {
							"primaryAccessCode": auth.authorization.firstAuthorizationMode,
                        "secondaryAccessCode": auth.authorization.secondAuthorizationMode,
                        "isMobileNTFConfirmation": auth.authorization.isMobileNTFConfirmation
						  };
              if(auth.authorization.transactionType){
                this.header.transactionType=auth.authorization.transactionType;
              }
						  self.headerObject = this.header;
						  self.setAuthorizationModes(this.header);

						  self._callAuthPage();
					}
                    else{
                        if(typeof self._errorHandler == 'function')
                            self._errorHandler(event);
                        self.fire('oe-show-error', event.detail.error.message);
                    }
                } else {
                    //Headers is obtained as a single string and JSON.stringify will stringify the whole string hence broken down
                    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
                    var headers = convertedArr.reduce(function (each, current) {
                        var parts = [current.split(": ",1).toString(), current.split(": ").slice(1).join(": ")];
                        each[parts[0]] = parts[1];
                        return each;
                    }, {});
                //code changes for defect 416910//start
                if (typeof self._errorHandler == 'function')
                    self._errorHandler();
                //end
                if (headers.channelcontext) {
                    self.fire('oe-show-error', JSON.parse(headers.channelcontext).status.message[0]
                        .messageDesc);
                } else {
                        self.fire('oe-show-error', event.detail.error.message);
                }
                // code changes for 453954
                window.addEventListener('resetAuthMethod', function() {
                    if (self.authMethods.length && Object.values(self.authMethods[self.authMethods.length - 1]).includes("OOBN")) {
                        self.authMethods = [];
                    }
                });
                }
            });
            oeAjaxEventListner(ajaxCall);
            ajaxCall.generateRequest();
            
        },

        setAuthorizationModes: function (header) {
            
            this.authMethods=[];
            if (header.primaryAccessCode == "TPWD" && (!header.secondaryAccessCode ||
                    header.secondaryAccessCode =='')) {
                this.authMethods = [{
                    'method': 'TPWD',                    
                    'wrapperValue': ''}];
            }
            if (header.primaryAccessCode == "SOTP" && (!header.secondaryAccessCode ||
                    header.secondaryAccessCode =='')) {
                this.authMethods = [{
                    'method': 'SOTP',
        'resendUrl': 'authorization',
        'wrapperValue': '',
        'userId': clientStorage.get(storageType.session, 'uniqueUserId'),
        'corpId': clientStorage.get(storageType.session, 'corpId'),
        'transactionType':header.transactionType
      }];
            }            
            if (header.primaryAccessCode == "TPWD" && header.secondaryAccessCode == "SOTP" || header.secondaryAccessCode == "OTP") {
                this.authMethods = [{
                    'method': 'TPWD',                    
                    'wrapperValue': ''
                }, {
                    'method': 'SOTP',
        'resendUrl': 'authorization',
        'wrapperValue': '',
        'userId': clientStorage.get(storageType.session, 'uniqueUserId'),
        'corpId': clientStorage.get(storageType.session, 'corpId'),
        'transactionType':header.transactionType
                }];
            }
			if (header.primaryAccessCode == "SOTP" && header.secondaryAccessCode == "TPWD") {
                this.authMethods = [ {
                    'method': 'SOTP',
        'resendUrl': 'authorization',
        'wrapperValue': '',
        'userId': clientStorage.get(storageType.session, 'uniqueUserId'),
        'corpId': clientStorage.get(storageType.session, 'corpId'),
        'transactionType':header.transactionType
      }, {
        'method': 'TPWD',
        'wrapperValue': ''
      }];
    }

    if (header.primaryAccessCode == "OOBN" && (!header.secondaryAccessCode || header.secondaryAccessCode == '')) {
      this.authMethods = [{
        'method': 'OOBN',
        'wrapperValue': '',
        'isMobileNTFConfirmation': header.isMobileNTFConfirmation
      }];
    }
        },		
		authenticationValidation: function (autharray) {
			var authMethodLength = autharray.length;
			for (var i = 0; i < authMethodLength; i++) {
				if (autharray[i].method == "OTP" || autharray[i].method == "SOTP") {
					if (!autharray[i].wrapperValue) {
						this.fire('oe-show-error', getLabel("m_OTPMandatory"));
						return true;
					}
				} else if (autharray[i].method == "TPWD") {
					if (!autharray[i].wrapperValue) {
						this.fire('oe-show-error', getLabel("m_TPWDMandatory"));
						return true;
					}
				}
			}
		}
    }
